<template>
  <svg
    :viewBox="`0 0 ${width} ${height}`"
    style="display: block"
    class="caption"
  >
    <defs>
      <clipPath id="themes-line-chart-clip">
        <rect
          :x="margin.left - 1"
          y="0"
          :width="width - margin.left - margin.right + 2"
          :height="height + margin.bottom"
        ></rect>
      </clipPath>
    </defs>
    <g :transform="`translate(${margin.left},0)`">
      <g v-for="t in yTicks" :key="t" :transform="`translate(0,${y(t)})`">
        <text fill="currentColor" x="-9" dy="0.32em" text-anchor="end">
          {{ formatYTick(t) }}
        </text>
        <line
          stroke="currentColor"
          stroke-opacity="0.3"
          :x1="width - margin.left - margin.right"
        ></line>
      </g>
    </g>
    <g :transform="`translate(0,${height - margin.bottom})`">
      <g v-for="t in xTicks" :key="t" :transform="`translate(${x(t)},0)`">
        <text fill="currentColor" y="9" dy="0.71em" text-anchor="middle">
          {{ t }}
        </text>
        <line
          stroke="currentColor"
          stroke-opacity="0.3"
          :y1="-(height - margin.top - margin.bottom)"
        ></line>
      </g>
    </g>
    <g clip-path="url(#themes-line-chart-clip)">
      <g
        v-for="s in lineData"
        :key="s.key"
        :opacity="isItemOpaque(s.key) ? 0.05 : 1"
      >
        <path :stroke="s.color" fill="none" :d="linePath(s.values)"></path>
        <circle
          v-for="d in s.values.filter(d => d[yValueMode])"
          :key="d.year"
          :fill="s.color"
          :r="dotRadius"
          :cx="x(d.year)"
          :cy="y(d[yValueMode])"
          :stroke-width="dotRadius * 2"
          stroke="transparent"
          style="pointer-events: all;"
          @mouseenter="dotEntered(d, $event)"
          @mouseleave="dotLeft"
        ></circle>
      </g>
    </g>
    <g
      v-if="!!focusDot"
      stroke-dasharray="4"
      stroke="currentColor"
      stroke-opacity="0.3"
    >
      <line
        :x1="margin.left"
        :x2="x(focusDot.year)"
        :y1="y(focusDot[yValueMode])"
        :y2="y(focusDot[yValueMode])"
      ></line>
      <line
        :x1="x(focusDot.year)"
        :x2="x(focusDot.year)"
        :y1="height - margin.bottom"
        :y2="y(focusDot[yValueMode])"
      ></line>
    </g>
  </svg>
</template>

<script>
import { scaleLinear } from "d3-scale";
import { line } from "d3-shape";
import { max } from "d3-array";

export default {
  props: {
    width: {
      type: Number,
      required: true
    },
    brushedYearRange: {
      type: Array,
      required: true
    },
    lineData: {
      type: Array,
      required: true
    },
    isItemOpaque: {
      type: Function,
      required: true
    },
    yValueMode: {
      type: String,
      required: true
    },
    formatYTick: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    height: 160,
    margin: { top: 20, right: 20, bottom: 20, left: 40 },
    dotRadius: 4,
    focusDot: null
  }),
  computed: {
    x() {
      return scaleLinear()
        .domain([
          this.brushedYearRange[0] - 0.5,
          this.brushedYearRange[1] + 0.5
        ])
        .range([this.margin.left, this.width - this.margin.right]);
    },
    y() {
      return scaleLinear()
        .domain([
          0,
          max(this.lineData, d => max(d.values, d => d[this.yValueMode]))
        ])
        .range([
          this.height - this.margin.bottom - this.dotRadius,
          this.margin.top + this.dotRadius
        ]);
    },
    linePath() {
      return line()
        .x(d => this.x(d.year))
        .y(d => this.y(d[this.yValueMode]));
    },
    xTicks() {
      return this.x
        .ticks((this.width - this.margin.left - this.margin.right) / 80)
        .filter(d => d % 1 === 0);
    },
    yTicks() {
      let yTicks = this.y.ticks(this.height / 40);
      if (this.yValueMode === "count") {
        yTicks = yTicks.filter(i => i % 1 === 0);
      }
      return yTicks;
    }
  },
  methods: {
    dotEntered(d, event) {
      this.focusDot = d;
      this.$emit("enter-dot", d, event);
    },
    dotLeft() {
      this.focusDot = null;
      this.$emit("leave-dot");
    }
  }
};
</script>
